import axios from "axios";
import AuthHelper from "@/services/admin/authHelper";
const authHelper = new AuthHelper();

export default class HotelsApi {



  async suggest(agencyId, destination) {
    return await axios.get(`/api/hotels/suggest/${agencyId}/${destination}`);
  }

  async cheapestOne(agencyId, city, hotel, airport, checkIn, checkOut, rooms, adults, children, currency, sort, limit) {
    return await axios.get(`/api/hotels/cheapestOne/${agencyId}/${currency}/${city}/${hotel}/${airport}/${checkIn}/${checkOut}/${rooms}/${adults}/${children}/${sort}/${limit}`);
  }
  async search(city, hotel, airport, checkIn, checkOut, rooms, adults, children, currency, sort, limit) {
    return await axios.post('/api/hotels/search', {
      city: city,
      hotel: hotel,
      airport: airport,
      checkIn: checkIn,
      checkOut: checkOut,
      rooms: rooms,
      adults: adults,
      children: children,
      currency: currency,
      sort: sort,
      limit: limit
    });
  }

  async searchHotel(hotel, checkIn, checkOut, rooms, adults, children, currency) {
    return await axios.post('/api/hotels/search', {
      hotel: hotel,
      checkIn: checkIn,
      checkOut: checkOut,
      rooms: rooms,
      adults: adults,
      children: children,
      currency: currency,
      sort: 'gs',
    });
  }

  async photos (hotelId) {
    return await axios.post('/api/hotels/photos', {
      hotelId: hotelId
    });
  }

  async reviews (hotelId) {
    return await axios.post('/api/hotels/reviews', {
      hotelId: hotelId
    });
  }

  async details (hotelId, checkIn, checkOut, rooms, adults, children, currency) {
    return await axios.post('/api/hotels/details', {
      hotelId: hotelId,
      checkIn: checkIn,
      checkOut: checkOut,
      rooms: rooms,
      adults: adults,
      children: children,
      currency: currency
    });
  }

  async availability (ppn) {
    return await axios.post('/api/hotels/availability', {ppn: ppn});
  }

  async book (ppn, bookData) {
    let headers = await authHelper.getAuthHeaders();
    return await axios.post('/api/hotels/book', {ppn: ppn, bookData: bookData}, {headers});
  }

  async getOrder(bookingId, email) {
    return await axios.post(`/api/orders/hotels/${bookingId}/${email}`, {});
  }

  async shareHotelOrderDetailsByEmail(bookingId, lookupEmail, recepient) {
    return await axios.post('/api/orders/hotels/shareOrderByEmail', {
      bookingId, lookupEmail, recepient
    });
  }

  async updateOrderServiceFee(bookingId, serviceFee, paid) {
    let headers = await authHelper.getAuthHeaders();
    return await axios.post(`/api/admin/orders/hotels/${bookingId}/updateServiceFee`, {
      serviceFee,
      paid
    }, {headers})
  }

  async cancelOrder(bookingId, email, cancelPpn) {
    let headers = await authHelper.getAuthHeaders();
    return await axios.post('/api/hotels/cancelOrder', {
      bookingId: bookingId,
      email: email,
      cancelPpn: cancelPpn
    }, {headers});
  }
}